export const dialogMesasage = {
  SUPPLIERALLOWDELETE: 'Are you sure you want to delete supplier ?',
  SUPPLIERDONTALLOWDELETE: 'You are about to delete supplier. Before deleting, please make sure all associations and users are removed.'
};
